import PropTypes from 'prop-types';
import React from 'react';
import { Table, Button } from 'antd';
import { ImageIcon, FileIcon, eventListener } from '../utils';
const productionId = '101';
class OneNameHistory extends React.Component {
  static propTypes = {
    leftHeight: PropTypes.number,
    oneNameList: PropTypes.array,
    toViewer: PropTypes.func,
  };

  state = {
    selectedNameData: {},
  };

  componentDidMount() {}
  toImageEvent = () => {
    const [pageId, moduleId, elementId] = ['10019', 'mk0003', 'ns-011'];
    eventListener({ productionId, pageId, moduleId, elementId });
  };
  getLeftTabColumns = () => {
    const columns = [
      {
        title: '申请日期',
        dataIndex: 'applicationTime',
        key: 'applicationTime',
        width: '35%',
        render: value => <span>{value.split(' ')[0]}</span>,
        align: 'center',
      },
      {
        title: '影像',
        key: 'image',
        width: '20%',
        render: record => (
          <Button
            className="report-image"
            onClick={() => {
              this.toImageEvent();
              this.props.toViewer('history', record);
            }}
          >
            <ImageIcon />
          </Button>
        ),
        align: 'center',
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: '20%',
        align: 'center',
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: '25%',
        align: 'center',
      },
    ];
    return columns;
  };

  changeHistoryData = record => {
    this.setState({ selectedNameData: record || {} });
  };

  render() {
    const { leftHeight, oneNameList } = this.props;
    const { selectedNameData } = this.state;
    const columns = this.getLeftTabColumns();

    let partList = [];
    if (selectedNameData.parts) {
      selectedNameData.parts.forEach(item => {
        partList.push(item.bodyPartName + '/' + item.checkPostureName);
      });
    }
    partList.join(';');
    return (
      <div className="report-left" style={{ height: leftHeight }}>
        <p className="report-history-tip">
          提示：由于乡镇卫生院没有患者唯一标识号（就诊卡号、身份证号等），无法准确检索出患者历史信息，现采用当前申请机构下患者姓名查询，可能出现同名，请仔细核对影像加以识别！！
        </p>
        <Table
          columns={columns}
          dataSource={oneNameList}
          bordered
          pagination={false}
          className="report-history-table"
          rowKey={record => record.applicationId}
          onRow={record => {
            return {
              onClick: event => this.changeHistoryData(record), // 点击行
            };
          }}
        />
        <div className="report-history-content">报告内容</div>
        <div className="report-history-list">
          <div className="report-history-title">
            <FileIcon /> 检查部位
          </div>
          <div className="report-history-text">{partList}</div>
        </div>
        <div className="report-history-list">
          <div className="report-history-title">
            <FileIcon /> 病史
          </div>
          <div className="report-history-text">
            {selectedNameData.medicalHistory}
          </div>
        </div>
        <div className="report-history-list">
          <div className="report-history-title">
            <FileIcon /> 影像所见
          </div>
          <div className="report-history-text">
            {selectedNameData.radiographyDescription}
          </div>
        </div>
        <div className="report-history-list">
          <div className="report-history-title">
            <FileIcon /> 诊断建议
          </div>
          <div className="report-history-text">
            {selectedNameData.diagnosisDescription}
          </div>
        </div>

        {selectedNameData.reportUserName && (
          <div className="report-history-doctor">
            报告医生 {selectedNameData.reportSignature}
            {selectedNameData.reportTime}
          </div>
        )}
        {selectedNameData.verifyUserName && (
          <div className="report-history-doctor">
            审核医生 {selectedNameData.verifySignature}
            {selectedNameData.reportTime}
          </div>
        )}
      </div>
    );
  }
}

export default OneNameHistory;
